<template>
  <div class="cost">
    <vxe-grid
      border
      show-overflow
      resizable
      ref="table"
      class="vxe-table-element"
      size="mini"
      align="left"
      :auto-resize="true"
      :data="tableData"
      :max-height="tableHeight"
      :columns="columnList"
      show-footer
      :footer-method="footerMethod"
      column-min-width="120"
    >
    </vxe-grid>
  </div>
</template>
<script>
  import fullScreenDialog from '@/common/mixins/fullScreenDialog.js';
  export default {
    mixins: [fullScreenDialog],
    name: 'cost',
    computed: {
      columnList() {
        return [
          { type: 'seq', width: 60, title: this.$t('table.index'), fixed: 'left' }, // 序号
          {
            field: 'serializationJsonData.payableInvoiceCreateDate',
            title: this.$t('batchAdd.cost.payableInvoiceCreateDate'),
          }, // 发票日期
          {
            field: 'serializationJsonData.invoiceUnitName',
            title: this.$t('batchAdd.cost.invoiceUnitName'),
          }, // 开票单位
          {
            field: 'serializationJsonData.invoiceCode',
            title: this.$t('batchAdd.cost.invoiceCode'),
          }, // 发票号
          {
            // 开票金额
            field: 'serializationJsonData.totalAmount',
            title: this.$t('batchAdd.cost.totalAmount'),
            slots: {
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.formatTableColumn(row.serializationJsonData.totalAmount)}
                  </span>,
                ];
              },
            },
          },
          {
            // 税率
            field: 'serializationJsonData.taxRate',
            title: this.$t('batchAdd.cost.taxRate'),
            slots: {
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.formatTableColumn(
                      row.serializationJsonData.taxRate,
                      this.$globalVar.tPoint
                    )}
                  </span>,
                ];
              },
            },
          },
          {
            // 税额
            field: 'serializationJsonData.taxAmount',
            title: this.$t('batchAdd.cost.taxAmount'),
            slots: {
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.formatTableColumn(row.serializationJsonData.taxAmount)}
                  </span>,
                ];
              },
            },
          },
          {
            // 不含税金额
            field: 'serializationJsonData.amountWithoutTax',
            title: this.$t('batchAdd.cost.amountWithoutTax'),
            slots: {
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.formatTableColumn(
                      row.serializationJsonData.amountWithoutTax
                    )}
                  </span>,
                ];
              },
            },
          },
          {
            field: 'serializationJsonData.expenseType',
            title: this.$t('batchAdd.cost.expenseType'),
            formatter: this.formatterExpenseType,
          }, // 费用类型
          {
            field: 'serializationJsonData.belongPeriod',
            title: this.$t('batchAdd.cost.belongPeriod'),
          },
          {
            field: 'serializationJsonData.isPaid',
            title: this.$t('batchAdd.cost.isPaid'),
            formatter: this.formatterIsPaid,
          },
          {
            field: 'serializationJsonData.supplierName',
            title: this.$t('batchAdd.cost.supplierName'),
          },
          { field: 'serializationJsonData.mark', title: this.$t('batchAdd.cost.mark') },
        ];
      },
    },
    data() {
      return {
        tableData: [],
      };
    },
    methods: {
      formatterIsPaid({ cellValue }) {
        return this.$baseRequest.getDictValueByType('yes-no', cellValue);
      },
      formatterExpenseType({ cellValue }) {
        return this.$baseRequest.getDictValueByType('expense_type', cellValue);
      },
      footerMethod({ columns, data }) {
        let returnProps = [
          'serializationJsonData.totalAmount',
          'serializationJsonData.taxAmount',
          'serializationJsonData.amountWithoutTax',
        ];
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return this.$t('xTable.total');
            }
            if (returnProps.includes(column.property)) {
              let subtrahend = 0;
              data.map((item) => {
                subtrahend = this.$cal.calCommon(
                  item.serializationJsonData[column.property.replace('serializationJsonData.', '')],
                  subtrahend,
                  '+'
                );
              });
              return this.$baseRequest.formatTableColumn(subtrahend);
            }
            return null;
          }),
        ];
      },
    },
  };
</script>
